import { UTCDate } from '@date-fns/utc';

import type { TalentDiscoveryAiFilterSearchResponseV2 } from '@revelio/data-access';

import { dateRangeDefinition } from '../../definitions/dateRange';
import type { DateRangeFilter } from '../../types/filters';

const parseAiDateToUtcDate = (
  dateStr: string | null | undefined
): UTCDate | null => {
  if (!dateStr) {
    return null;
  }
  // dash-meta now emits full ISO dates (YYYY-MM-DD). Keep the day; fall back to
  // the first of the month if only YYYY-MM is present. Consumers decide
  // granularity (Talent Discovery floors to the month, Posting uses the day).
  const match = dateStr.match(/^(\d{4})-(\d{2})(?:-(\d{2}))?/);
  if (!match?.[1] || !match[2]) {
    return null;
  }
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = match[3] ? Number(match[3]) : 1;
  if (month < 1 || month > 12 || day < 1 || day > 31) {
    return null;
  }
  return new UTCDate(year, month - 1, day);
};

/**
 * Maps top-level AI Search `date_range` (not in filters.expr) to a CustomDash DATE_RANGE filter.
 */
export const transformAiDateRangeToCustomDashFilter = (
  dateRange: TalentDiscoveryAiFilterSearchResponseV2['date_range']
): DateRangeFilter | null => {
  if (dateRange === null || dateRange === undefined) {
    return null;
  }

  const min = parseAiDateToUtcDate(dateRange.start_value);
  const max = parseAiDateToUtcDate(dateRange.end_value);

  if (min === null && max === null) {
    return null;
  }

  return {
    ...dateRangeDefinition,
    min,
    max,
    isUserSubmitted: true,
    isVisible: true,
  };
};
